import { useContext, useState } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { useQueryClient } from 'react-query';

type UseAddUserToGroupModalFacade = (groupId: string) => {
  isAddUserToGroupModalOpen: boolean,
  openAddUserToGroupModal: () => void,
  closeAddUserToGroupModal: () => void,
  onUserAdditionSuccess: () => void,
};

export const useAddUserToGroupModalFacade: UseAddUserToGroupModalFacade = (groupId) => {
  const [isAddUserToGroupModalOpen, setIsAddUserToGroupModalOpen] = useState(false);

  const queryClient = useQueryClient();

  const { showNotification } = useContext(NotificationsContext);

  const openAddUserToGroupModal = () => setIsAddUserToGroupModalOpen(true);

  const closeAddUserToGroupModal = () => setIsAddUserToGroupModalOpen(false);

  const onUserAdditionSuccess = () => {
    queryClient.invalidateQueries([`group-${groupId}-users`]).then();
    showNotification('User successfully added!');
    closeAddUserToGroupModal();
  };

  return {
    isAddUserToGroupModalOpen,
    openAddUserToGroupModal,
    closeAddUserToGroupModal,
    onUserAdditionSuccess,
  };
}
